export class ApplicationIngestionApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Ingests an application file into an organization's application pool.
     * @returns any
     * @throws ApiError
     */
    process({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/application-ingestion/process',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
